import "./index.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

// App dependencies
import React, { Suspense } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import LoadingPage from "@jnctn-app/pages/LoadingPage/LoadingPage";

if (window.rg4js) {
  window.rg4js("apiKey", import.meta.env["REACT_APP_RAYGUN_API_KEY"]);
  window.rg4js("withTags", ["jnctn-enterprise", "react"]);
  window.rg4js("enableCrashReporting", true);
  window.rg4js("enablePulse", true);
  window.rg4js("setVersion", import.meta.env["REACT_APP_VERSION"]);
  window.rg4js("options", { ignore3rdPartyErrors: true });
}

const rootElement = document.getElementById("root");
if (rootElement) {
  const app = (
    <React.StrictMode>
      <Suspense fallback={<LoadingPage />}>
        <App />
      </Suspense>
    </React.StrictMode>
  );
  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
  } else {
    const root = createRoot(rootElement!);
    root.render(app);
  }
}
